import { shouldUpdate } from 'recompose';
import RenderCallback from './RenderCallback';

export default shouldUpdate((_, { block }) => !block)(RenderCallback);
